/* src/app/hire-person-search/add-to-pipeline/add-to-pipeline.component.scss */
@keyframes shimmer {
  0% {
    background-position: -600px 0;
  }
  100% {
    background-position: 600px 0;
  }
}
.sk-box {
  border-radius: 10px;
  background:
    linear-gradient(
      90deg,
      #f0f0f0 25%,
      #e0e0e0 50%,
      #f0f0f0 75%);
  background-size: 1200px 100%;
  animation: shimmer 1.6s infinite linear;
  flex-shrink: 0;
}
.skeleton-page {
  background: #fff;
  border-radius: 8px;
  padding: 14px 18px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-width: 100%;
  font-size: 0;
}
.divider {
  height: 1px;
  background: #f0f0f0;
  margin: 8px 0;
}
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.toolbar-left {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}
.toolbar-right {
  display: flex;
  align-items: center;
  gap: 8px;
}
.toolbar-actions {
  display: flex;
  gap: 6px;
}
.checkbox {
  width: 16px;
  height: 16px;
  border-radius: 3px;
}
.title-bar {
  width: 180px;
  height: 10px;
}
.icon-btn {
  width: 24px;
  height: 22px;
  border-radius: 4px;
}
.btn-lg {
  width: 110px;
  height: 28px;
  border-radius: 5px;
}
.btn-md {
  width: 80px;
  height: 28px;
  border-radius: 5px;
}
.subtitle-row {
  padding-left: 24px;
  margin-bottom: 6px;
}
.subtitle {
  width: 280px;
  height: 6px;
  border-radius: 10px;
}
.breadcrumb-row {
  display: flex;
  align-items: center;
  gap: 6px;
  padding-left: 24px;
}
.crumb {
  height: 6px;
  border-radius: 10px;
}
.crumb--sm {
  width: 80px;
}
.crumb--md {
  width: 120px;
}
.crumb--lg {
  width: 180px;
}
.dot {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  flex-shrink: 0;
}
.chips-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.chip-label {
  width: 90px;
  height: 6px;
}
.chip {
  height: 16px;
  border-radius: 12px;
  min-width: 60px;
}
.data-rows {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.data-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 4px 0;
}
.row-content {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
}
.row-title {
  height: 13px;
  border-radius: 10px;
}
.meta-tag {
  height: 7px;
  border-radius: 10px;
}
.row-meta {
  display: flex;
  align-items: center;
  gap: 6px;
}
.footer-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-top: 4px;
  flex-wrap: wrap;
  justify-content: space-between;
}
.footer-card {
  height: 28px;
  border-radius: 5px;
}
.button {
  height: 28px;
  width: 115px;
  position: relative;
  border-radius: 0px 8px 8px 0px;
  background-color: #f4f4f4;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  padding: 4px 12px 4px 0px;
  box-sizing: border-box;
}
.button-child {
  height: 28px;
  width: 16px;
  position: relative;
  flex-shrink: 0;
}
.vector-icon {
  height: 28px;
  width: 100%;
  position: relative;
  background-color: #eeeeee;
}
@media (prefers-reduced-motion: reduce) {
  .sk-box {
    animation: none;
    background: #eeeeee;
  }
}
.table-sk-view,
.table-sk-3-column-view {
  border-radius: 4px;
  border: 1px solid #F2F2F2;
  width: 100%;
}
.table-sk-view .table-sk-header,
.table-sk-3-column-view .table-sk-header {
  background: #FAFBFC;
  border-bottom: 1px solid #F2F2F2;
  width: 100%;
  display: flex;
}
.table-sk-view .table-body-row,
.table-sk-3-column-view .table-body-row {
  border-bottom: 1px solid #F2F2F2;
  width: 100%;
  display: flex;
  background-color: #fff;
}
.table-sk-view .table-sk-col,
.table-sk-3-column-view .table-sk-col {
  border-right: 1px solid #F2F2F2;
  padding: 12px 16px;
  width: 30%;
}
.table-sk-view .table-sk-col:last-child,
.table-sk-3-column-view .table-sk-col:last-child {
  border-right: none;
  width: 70%;
}
.table-sk-3-column-view .table-sk-3-col {
  border-right: 1px solid #F2F2F2;
  padding: 12px 16px;
}
.table-sk-3-column-view .table-sk-3-col:last-child {
  border-right: none;
  width: 35%;
}
.table-sk-3-column-view .table-sk-3-col:nth-of-type(2) {
  width: 35%;
}
.table-sk-3-column-view .table-sk-3-col:first-child {
  width: 30%;
}
.custom-dropdown-menu {
  position: absolute;
  z-index: 1;
  background: #fff;
  border-radius: 8px;
  min-width: 220px;
  width: 100%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transform: translate3d(0px, 0px, 0px) !important;
  inset: auto 0px auto auto;
}
.custom-dropdown-menu .custom-dropdown-search {
  position: relative;
  padding: 8px;
  border-bottom: 1px solid #f0f0f0;
}
.custom-dropdown-menu .custom-dropdown-search .search-icon {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: #999;
  font-size: 12px;
}
.custom-dropdown-menu .custom-dropdown-search .search-input {
  width: 100%;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 4px 8px 4px 28px;
  font-size: 12px;
  outline: none;
}
.custom-dropdown-menu .custom-dropdown-search .search-input:focus {
  border-color: #2e93a1;
}
.custom-dropdown-menu .custom-dropdown-list {
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 200px;
  overflow-y: auto;
}
.custom-dropdown-menu .custom-dropdown-list .custom-dropdown-item {
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  color: #484B59;
}
.custom-dropdown-menu .custom-dropdown-list .custom-dropdown-item.disabled {
  color: #999;
  cursor: default;
  background: #f7f7f7;
}
.custom-dropdown-menu .custom-dropdown-list .custom-dropdown-item:hover,
.custom-dropdown-menu .custom-dropdown-list .custom-dropdown-item.active {
  background: rgba(46, 147, 161, 0.08);
  color: #2e93a1;
}
.custom-dropdown-menu .custom-dropdown-list .custom-dropdown-item.no-results {
  color: #999;
  cursor: default;
  text-align: center;
}
.custom-dropdown-menu .custom-dropdown-footer {
  padding: 8px 16px;
  border-top: 1px solid #f0f0f0;
  font-size: 14px;
  color: #2e93a1;
  cursor: pointer;
  font-weight: 500;
}
.custom-dropdown-menu .custom-dropdown-footer:hover {
  background: rgba(46, 147, 161, 0.08);
}
.ats-dropBtn button {
  padding: 0;
  border: none;
  color: #969696;
  outline: none;
  background-color: #fff;
}
.ats-dropBtn button.dropdown-toggle::after {
  display: none;
}
.ats-dropBtn .dropdown-menu.show {
  left: -125px !important;
  transform: translate3d(-33px, 17px, 0px) !important;
  padding: 0;
  overflow: hidden;
}
.ats-dropBtn .dropdown-menu.show .dropdown-item {
  padding: 0.75rem 0.75rem;
}
.ats-dropBtn .dropdown-menu.show .dropdown-item:hover {
  background-color: #E4F1F3;
}
.add-to button.btn-trms-light {
  background-color: #F4F4F4;
  color: #484b59;
  font-size: 12px;
  height: auto;
  border-color: #F4F4F4;
}
.add-to button.btn-trms-medium {
  font-size: 12px;
  height: auto;
}
.add-to .dropdown-menu.show {
  top: 40px;
  left: -55px;
  width: 220px;
  height: 160px;
  overflow-y: auto;
  border-radius: 4px;
  border: 1px solid #F5F5F5;
  background: #FFF;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
  font-size: 12px;
}
.add-to .dropdown-menu.show .dropdown-item {
  padding: 8px 10px;
}
.add-to .dropdown-menu.show .dropdown-item:hover {
  background-color: #F4F9FA;
  color: #2E93A1 !important;
}
.add-to .dropdown-menu.show .optionheader {
  padding: 10px;
  position: relative;
  color: #969696;
}
.add-to .dropdown-menu.show .optionheader::after {
  position: absolute;
  display: block;
  content: "";
  width: 25%;
  height: 2px;
  background-color: #F2F2F2;
  right: 10px;
  top: 16px;
}
.add-to .dropdown-menu.show::-webkit-scrollbar {
  width: 3px !important;
}
.add-to .dropdown-menu.show::-webkit-scrollbar-track {
  background: #F2F2F2 !important;
}
.add-to .dropdown-menu.show::-webkit-scrollbar-thumb {
  background: #D9D9D9 !important;
}
.add-to .dropdown-menu.show::-webkit-scrollbar-thumb:hover {
  background: #555 !important;
}
.pipeline-btn-wrapper {
  position: relative;
}
.pipeline-btn-wrapper.pipeline-btn-loading > :not(.pipeline-btn-skeleton) {
  visibility: hidden;
}
.pipeline-btn-skeleton {
  position: absolute;
  inset: 0;
  z-index: 1;
  border-radius: 5px;
}
.hire-btn-group .btn-trms-medium {
  min-width: 115px;
  width: calc(100% - 32px);
  margin: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  font-size: 12px;
  height: auto;
}
.hire-btn-group .dropdown-toggle-split {
  min-width: 30px;
  width: 30px;
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border-left: 1px solid rgba(255, 255, 255, 0.5);
}
.hire-btn-group .dropdown-toggle-split:focus {
  background-color: #2E93A1;
  opacity: 0.9;
}
.hire-btn-group .dropdown-menu.show {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  border: none;
  font-size: 12px;
  color: #484b59;
}
.hire-btn-group .custom-dropdown-menu {
  top: 30px;
  left: 0px;
  transform: translate3d(0px, 0px, 0px) !important;
  inset: 33px 0px auto auto;
}
.hire-btn-group .loading-state {
  opacity: 0.75;
  width: 145px;
  border-radius: 4px;
}
.rotate-caret::after {
  transform: rotate(180deg);
}
/*# sourceMappingURL=add-to-pipeline.component-TIXG32LV.css.map */
